<template>
  <div>
    <div class="login-sign" style="max-width: 1200px">
      <div class="form-wrap">
        <h2 class="cont-head">החלף שם</h2>
        <form
          @submit.prevent="changeUserName()"
          class="w-form"
          id="email-form"
          name="email-form"
          data-name="Email Form"
                v-if="!this.success"
        >
          <input
            type="text"
            class="text-field w-input"
            maxlength="256"
            name="name"
            data-name="Name"
            placeholder="הזן את שמך"
            required
            v-model="userName"
          />

          <div class="btn-wrapper sign path-action">
            <input type="submit" value="שנה לי את השם" data-wait class="btn sign w-button" />
          </div>
          <p v-if="this.signInError" class="sign-link" style="color:red">{{ this.getErrMsg }}</p>
        </form>

        <div class="w-form-done" v-if="this.success">
          <div>שמך השתנה בהצלחה</div>
        </div>
        <div class="w-form-fail" v-if="this.error">
          <div>חלה שגיאה בעת שינוי השם. אנא נסה שנית מאוחר יותר</div>
        </div>
      </div>

      <div style="text-align:center">
        <loader v-if="this.loading" />
      </div>

      <div class="select-path">
        <h2 class="cont-head">בחר מסלולים נוספים</h2>
        <div class="flexboxes" v-if="cbPaths && cbPaths.length > 0">
          <div
            class="path-box w-inline-block"
            :class="{'selected':paths.includes(item._id)}"
            v-for="item in cbPaths"
            :key="item._id"
            @click="togglePath(item._id)"
          >
            <h3>{{item.title}}</h3>
            <p class="path-description">{{item.description}}</p>
          </div>
        </div>
        <div v-else style="text-align: center">
          <loader/>
        </div>
        <div class="path-action">
          <a @click="submitPaths()" class="btn sign w-button">הרשמה</a>
          <loader v-if="this.loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DATA_LOADING_STATE } from "@/store/enums";
import loader from "../components/loader";
export default {
  name: "settings",
  components: { loader },
  data() {
    return {
      paths: [],
      cbPaths: [],
      signInError: false,
      userName: this.getUser ? this.getUser.fullName : '',
    };
  },

  methods: {
    async submitPaths() {
      this.loading = true;
      console.log(this.paths);
      await this.registerPaths(this.paths);
      console.log("user doesn't approved");
      await this.$router.push({ name: "pathsNotRegistered" });
      this.loading = false;
    },
    changeUserName() {
      console.log(`change to ${this.userName}`);
      this.$store.dispatch("changeUserName", this.userName);
    },
    togglePath(id) {
      if (this.paths.includes(id)) {
        this.paths = this.paths.filter((path) => path != id);
      } else {
        this.paths.push(id);
      }
    },
    ...mapActions(["fetchCbPaths", "registerPaths"]),
  },
  computed: {
    ...mapGetters(["getErrMsg", "getLoading", "getUser", "getPaths"]),
    loading() {
      return this.getLoading === DATA_LOADING_STATE.CREATING;
    },
    error() {
      return this.getLoading === DATA_LOADING_STATE.ERROR;
    },
    success() {
      return this.getLoading === DATA_LOADING_STATE.CREATED;
    },
  },
  async created() {
    console.log('in created in settings');
    await this.$store.commit('setSignInit');
    await this.fetchCbPaths();
    this.cbPaths = this.getPaths;
    console.log(this.cbPaths)
    if(this.getUser.fullName){
      this.userName = this.getUser.fullName;
    }
    console.log(this.getUser)
  },
  watch:{
    getUser(){
      console.log('watch for getUser, now is:')
      console.log(this.getUser)
      this.userName = this.getUser.fullName;
      console.log(this.userName)
    },
    getPaths(){

      console.log('get paths state is:')
      console.log(this.getPaths)
      console.log(this.getUser.userPaths)
      let allPaths = this.getPaths;
      let userRegisteredPaths = this.getUser.userPaths? this.getUser.userPaths.map((registeredPath)=>registeredPath.itemRefID):[];
      let userPathsRequest = this.getUser.pathsRequest ? this.getUser.pathsRequest.map((requestPath)=>requestPath.itemRefID):[];
      let totalUserPaths = userRegisteredPaths.concat(userPathsRequest);
      // console.log('totalUserPaths')
      // console.log(totalUserPaths);
      this.cbPaths = allPaths.filter((genericPath)=>!totalUserPaths.includes(genericPath._id));
    }
  }
};
</script>

<style scoped>
.flexboxes {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-shrink: 0;
}
.path-box {
  height: 200px;
}
/*.path-box h3 {*/
/*  text-overflow: ellipsis;*/
/*  white-space: nowrap;*/
/*  overflow-x: hidden;*/
/*}*/
.form-wrap {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.select-path {
  margin-top: 50px;
}
.text-field {
  margin-bottom: 20px;
}
.cont-head {
  text-align: center;
  border-bottom: none;
  margin-bottom: 10px;
}
@media screen and (max-width: 1100px) {
  .path-box {
    width: 47.9%;
  }
}
@media screen and (max-width: 767px) {
  .path-box {
    width: 98%;
  }
}
@media screen and (max-width: 991px) {
  .login-sign {
    margin-top: 120px;
  }
}
@media screen and (max-width: 479px) {
  .login-sign {
    margin-top: 100px;
  }
}
</style>